import {
  GetPostProcessingPromptsResponse,
  PostProcessingPromptMap,
  TServerErrorResponse,
  UpsertPostProcessingPromptRequest,
} from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const GET_POST_PROCESSING_PROMPTS = "get-post-processing-prompts";

export const getPostProcessingPrompts =
  async (): Promise<PostProcessingPromptMap> => {
    try {
      const response = await http.get<GetPostProcessingPromptsResponse>(
        links.postProcessingPrompt.index,
      );
      return response.data?.prompts ?? {};
    } catch (error) {
      throw error as TServerErrorResponse;
    }
  };

export const upsertPostProcessingPrompt = async (
  data: UpsertPostProcessingPromptRequest,
): Promise<void> => {
  try {
    await http.put<void>(links.postProcessingPrompt.index, data);
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
